/**
 * on the event page, we do want to cache only one page and replace the dates via js
 */
export default class EventPage {
    static init() {
        const isEventPage = document.body.classList.contains('event-page');
        if (!isEventPage) {
            return;
        }

        const isNeosBackend = document.body.classList.contains('neos-backend');
        if(!isNeosBackend) {
            EventPage.replaceDates();
        }

        // finish loading
        Array.from(document.querySelectorAll('.event-page--hiddden-while-loading')).forEach(el => {
            el.classList.remove('event-page--hiddden-while-loading');
        });
    }

    static replaceDates() {
        // see if there is a date to replace
        const urlString = (window.location.href).toLowerCase();
        const url = new URL(urlString);
        const timestamp = url.searchParams.get('date');
        const selectedDate = window.eventDates ? window.eventDates[timestamp] : null;
        if(selectedDate) {
            Array.from(document.querySelectorAll('.event-page--set-long-form-date')).forEach(el => {
                el.innerText = selectedDate.longForm;
            });
            Array.from(document.querySelectorAll('.event-page--set-time-range')).forEach(el => {
                el.innerText = selectedDate.timeRange;
            });

            const calendarDropdown = document.querySelector('.calendar-dropdown');
            calendarDropdown.setAttribute('data-start', timestamp);
            calendarDropdown.setAttribute('data-end', selectedDate.endDateTimestamp);
        }
    }
}
